import { ButtonAction } from "../styles";

interface ActionsButtonStep1Props {
     handleCancel: (event: any) => void;
     handleSaveEdit: (event: any) => void;
}
export const ActionsButtonStep1 = ({ handleCancel, handleSaveEdit, }: ActionsButtonStep1Props) => {
     return (
          <div className="flex gap-4">
               <ButtonAction
                    onClick={handleCancel}
                    type="button"
                    className="text-blueTheme text-sm"
               >
                    Cancelar
               </ButtonAction>

               <ButtonAction
                    onClick={handleSaveEdit}
                    type="button"
                    className="bg-blueTheme text-white text-sm"
               >
                    Salvar edição
               </ButtonAction>
          </div>


     )
}
